module.exports = __webpack_public_path__ + "img/logo.6d8b58d8.svg";